<template>
  <b-modal
    :visible="value"
    @change="$emit('input', $event)"
    @hide="$emit('input', false)"
    title="Add Project Milestone"
    size="lg"
    hide-footer
    centered
  >
    <div class="form-group">
      <div class="row">
        <div class="col-12 mt-4">
          <label class="form-label">Task</label>
          <input
            v-model="bodyActivities.task"
            type="text"
            class="form-control"
            placeholder="Task"
          />
        </div>

        <div class="col-6 mt-4">
          <p class="form-label">Start Date</p>
          <input
            type="date"
            class="form-control"
            placeholder="Select Start Date"
            v-model="bodyActivities.startDate"
          />
        </div>
        <div class="col-6 mt-4">
          <p class="form-label">End Date</p>
          <input
            type="date"
            class="form-control"
            placeholder="Select End Date"
            v-model="bodyActivities.endDate"
          />
        </div>
        <div class="col-12 mt-4">
          <label>Percentage</label>
          <input
            v-model="bodyActivities.percentage"
            type="number"
            class="form-control"
            placeholder="Percentage"
            min="0"
            max="100"
          />
        </div>
        <div class="col-12 mt-4">
          <label>Assignee</label>
          <v-select
            multiple
            v-model="bodyActivities.assignee"
            :options="selectTeams"
            label="label"
            :reduce="(e) => e.nik"
            placeholder="Select Assignee"
          />
        </div>
      </div>
      <div class="mt-4">
        <b-button
          class="float-end"
          @click="submitActivities"
          variant="primary"
          :disabled="isSubmittingActivities"
        >
          <template v-if="isSubmittingActivities">
            <b-spinner small></b-spinner>
            Adding...
          </template>
          <template v-else> Add </template>
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "AddActivitiesExperiential",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    selectedTNA: {
      type: Object,
      default: null,
    },
    selectTeams: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isSubmittingActivities: false,
      bodyActivities: {
        id: "",
        task: "",
        startDate: "",
        endDate: "",
        percentage: "",
        assignee: [],
      },
    };
  },
  watch: {
    selectedTNA: {
      handler(newVal) {
        if (newVal) {
          // Check for iel_id in different possible locations
          this.bodyActivities.id =
            newVal.iel_id || newVal.project?.iel_id || newVal.id;
        }
      },
      immediate: true,
    },
  },
  methods: {
    formatDate(date) {
      if (!date) return "";
      return this.$moment(date).format("YYYY-MM-DD");
    },
    clearBodyActivities() {
      this.bodyActivities = {
        id: "",
        task: "",
        startDate: "",
        endDate: "",
        percentage: "",
        assignee: [],
      };
    },
    submitActivities() {
      this.isSubmittingActivities = true;

      let bodyAdd = {
        iel_id: this.bodyActivities.id,
        task: this.bodyActivities.task,
        start_date: this.formatDate(this.bodyActivities.startDate),
        end_date: this.formatDate(this.bodyActivities.endDate),
        percentage: this.bodyActivities.percentage,
        nik: this.bodyActivities.assignee,
      };

      this.$store
        .dispatch("myIdp/createProjectActivities", bodyAdd)
        .then((response) => {
          this.$swal(
            "Success",
            "Milestone proyek berhasil ditambahkan",
            "success"
          );
          this.$emit("input", false);
          this.$emit("refresh");
          this.clearBodyActivities();
          this.isSubmittingActivities = false;
        })
        .catch((error) => {
          this.$swal("Error", "Milestone belum berhasil ditambahkan!", "error");
          this.isSubmittingActivities = false;
        });
    },
  },
};
</script>
